const initialState = {
  results: [],
  term: '',
  type: null,
  isOpen: false,
  isSelected: false,
};

const reductions = {
  UPDATE_SEARCH: (state, action) => {
    return Object.assign({}, state, action.payload);
  },
  UPDATE_SEARCH_RESULTS: (state, action) => {
    return Object.assign({}, state, { results: action.payload });
  },
  UPDATE_SEARCH_TERM: (state, action) => {
    return Object.assign({}, state, { term: action.payload });
  },
  UPDATE_SEARCH_TYPE: (state, action) => {
    return Object.assign({}, state, { type: action.payload });
  },
  UPDATE_SEARCH_IS_OPEN: (state, action) => {
    return Object.assign({}, state, { isOpen: action.payload });
  },
  UPDATE_SEARCH_SELECTED: (state, action) => {
    return Object.assign({}, state, { isSelected: action.payload });
  },
};

const searchResultsReducer = (state = initialState, action) => {
  if (action && action.type && reductions[action.type]) {
    return reductions[action.type](state, action);
  }
  return state;
};

export default searchResultsReducer;
